module.exports = __webpack_public_path__ + "static/img/detail-collegeD.9b6e37f7.png";